export default __webpack_public_path__ + "static/media/apple.73099620.svg";